import { KeyValue } from "@/main/models/common";

export enum DamageZoneEnum {
	Front = "front",
	Left = "left",
	Roof = "roof",
	Right = "right",
	Rear = "rear",
}

export interface IDamageZone {
	zone: DamageZoneEnum;
	path: string;
	labelX: number;
	labelY: number;
	labelRotate?: number;
	translateKey: string;
	keywords: string[];
}

export interface IDamageAreasByZone {
	zones: Partial<Record<DamageZoneEnum, KeyValue>>;
	chips: KeyValue[];
}
